(function () {
  const KLAVIYO_POLL_INTERVAL = 200;
  const KLAVIYO_POLL_MAX = 50;
  const KLAVIYO_SUCCESS_TIMEOUT = 8000;

  function waitForKlaviyoForm(container) {
    return new Promise((resolve, reject) => {
      let attempts = 0;

      const timer = setInterval(() => {
        attempts += 1;

        const emailInput = container.querySelector('input[type="email"]');
        const klaviyoSubmit = container.querySelector(
          'button[type="button"], button[type="submit"]'
        );

        if (emailInput && klaviyoSubmit) {
          clearInterval(timer);
          resolve({ emailInput, klaviyoSubmit });
          return;
        }

        if (attempts >= KLAVIYO_POLL_MAX) {
          clearInterval(timer);
          reject(new Error('Klaviyo form not found'));
        }
      }, KLAVIYO_POLL_INTERVAL);
    });
  }

  function isKlaviyoSuccess(container) {
    return Boolean(
      container.querySelector('[data-testid*="success"]') ||
        container.querySelector('[data-testid*="Success"]') ||
        container.querySelector('[class*="success-message"]') ||
        container.querySelector('[class*="SuccessMessage"]')
    );
  }

  function showRewardSuccess(form) {
    if (form.classList.contains('is-success')) return;

    form.classList.add('is-success');

    const formBody = form.querySelector('[data-reward-form-body]');
    const successEl = form.querySelector('[data-reward-success]');
    const errorEl = form.querySelector('[data-reward-error]');
    const submitBtn = form.querySelector('[data-reward-submit]');

    if (formBody) formBody.hidden = true;
    if (successEl) successEl.hidden = false;
    if (errorEl) errorEl.hidden = true;
    if (submitBtn) submitBtn.disabled = false;
  }

  function initKlaviyoReward(form) {
    const klaviyoWrap = form.querySelector('[data-reward-klaviyo]');
    const submitBtn = form.querySelector('[data-reward-submit]');
    const errorEl = form.querySelector('[data-reward-error]');

    if (!klaviyoWrap || !submitBtn) return;

    let submitting = false;
    let successObserver = null;
    let fallbackTimer = null;

    const cleanupWatchers = () => {
      if (successObserver) {
        successObserver.disconnect();
        successObserver = null;
      }

      if (fallbackTimer) {
        clearInterval(fallbackTimer);
        fallbackTimer = null;
      }
    };

    const handleSuccess = () => {
      cleanupWatchers();
      submitting = false;
      showRewardSuccess(form);
    };

    waitForKlaviyoForm(klaviyoWrap)
      .then(({ emailInput, klaviyoSubmit }) => {
        submitBtn.addEventListener('click', () => {
          if (submitting || form.classList.contains('is-success')) return;

          const email = emailInput.value.trim();

          if (!email || !emailInput.checkValidity()) {
            if (errorEl) {
              errorEl.textContent = 'Please enter a valid email address.';
              errorEl.hidden = false;
            }
            emailInput.focus();
            return;
          }

          if (errorEl) errorEl.hidden = true;

          submitting = true;
          submitBtn.disabled = true;
          cleanupWatchers();

          successObserver = new MutationObserver(() => {
            if (isKlaviyoSuccess(klaviyoWrap)) {
              handleSuccess();
            }
          });

          successObserver.observe(klaviyoWrap, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
          });

          klaviyoSubmit.click();

          fallbackTimer = setInterval(() => {
            if (isKlaviyoSuccess(klaviyoWrap)) {
              handleSuccess();
            }
          }, 300);

          setTimeout(() => {
            if (form.classList.contains('is-success')) return;

            cleanupWatchers();
            submitting = false;
            submitBtn.disabled = false;

            if (errorEl) {
              errorEl.textContent = 'Submission failed. Please try again.';
              errorEl.hidden = false;
            }
          }, KLAVIYO_SUCCESS_TIMEOUT);
        });
      })
      .catch(() => {
        if (errorEl) {
          errorEl.textContent = 'Form is loading. Please refresh and try again.';
          errorEl.hidden = false;
        }
      });
  }

  function initRedirectReward(form, buttonUrl) {
    const emailInput = form.querySelector('[data-reward-email]');
    const errorEl = form.querySelector('[data-reward-error]');

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (!emailInput) return;

      const email = emailInput.value.trim();

      if (!email || !emailInput.checkValidity()) {
        if (errorEl) {
          errorEl.textContent = 'Please enter a valid email address.';
          errorEl.hidden = false;
        }
        emailInput.focus();
        return;
      }

      if (errorEl) errorEl.hidden = true;

      const target = new URL(buttonUrl, window.location.origin);
      target.searchParams.set('email', email);
      window.location.href = target.toString();
    });
  }

  function initRewardSection(section) {
    const form = section.querySelector('[data-reward-form]');
    if (!form) return;

    if (form.dataset.rewardMode === 'klaviyo') {
      initKlaviyoReward(form);
      return;
    }

    const buttonUrl = section.dataset.buttonUrl;
    if (buttonUrl) {
      initRedirectReward(form, buttonUrl);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-8th-reward]').forEach(initRewardSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.matches?.('[data-8th-reward]')
      ? event.target
      : event.target.querySelector?.('[data-8th-reward]');

    if (section) initRewardSection(section);
  });
})();
